// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"aT-z","inlineTitle":"bT-z","sponsoredAdsWrapper":"cT-z","marketplaceRecosWrapper":"dT-z"};